import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import BASE_URL from "../../../config/config";

const AddCourse = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "0",
    is_free: false,
    is_available: true,
    cover_pic: null,
    prerequisites: "",
    duration: "",
    level: "beginner",
    intro_video: null,
    discount: "0", // فیلد تخفیف اضافه شد
  });

  const handleChangeQuill = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value,
    }));
  };

  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState("");
  const [previewImage, setPreviewImage] = useState(null);

  const [isHtmlMode, setIsHtmlMode] = useState(false);
  const toolbarOptions = [
    [{ font: [] }, { size: [] }],
    [{ header: "1" }, { header: "2" }, { blockquote: true }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image"],
    ["code-block"],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          method: "GET",
          credentials: "include",
        });
        if (response.ok) {
          const data = await response.json();
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };
    fetchCsrfToken();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (file) {
        setFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
        if (name === "cover_pic") {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewImage(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
    } else if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
      if (name === "is_free" && checked) {
        setFormData((prev) => ({
          ...prev,
          price: "0",
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // محاسبه قیمت نهایی با تخفیف
  const calculateFinalPrice = () => {
    const price = parseFloat(formData.price) || 0;
    const discount = parseFloat(formData.discount) || 0;
    return price - (price * discount / 100);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });

      const response = await fetch(`${BASE_URL}/courses`, {
        method: "POST",
        headers: {
          "CSRF-Token": csrfToken,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: formDataToSend,
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("دوره با موفقیت ایجاد شد");
        setTimeout(() => {
          navigate("/admin/courses/list");
        }, 2000);
      } else {
        throw new Error(data.message || "خطا در ایجاد دوره");
      }
    } catch (error) {
      setMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-course-container">
      <h2>افزودن دوره جدید</h2>
      <form onSubmit={handleSubmit} className="add-course-form">
        <div className="form-group">
          <label htmlFor="title">عنوان دوره:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">توضیحات دوره:</label>

          {isHtmlMode ? (
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={(e) => handleChangeQuill(e.target.value)}
              rows="10"
              className="add-course-html-textarea"
            />
          ) : (
            <ReactQuill
              value={formData.description}
              onChange={handleChangeQuill}
              modules={modules}
              required
            />
          )}

          <button
            type="button"
            onClick={() => setIsHtmlMode((prevMode) => !prevMode)}
            className="add-course-toggle-html-button"
          >
            {isHtmlMode ? "ویرایش معمولی" : "ویرایش HTML"}
          </button>
        </div>

        <div className="form-group">
          <label htmlFor="cover_pic">تصویر دوره:</label>
          <input
            type="file"
            id="cover_pic"
            name="cover_pic"
            accept="image/*"
            onChange={handleChange}
          />
          {previewImage && (
            <div className="image-preview">
              <img src={previewImage} alt="پیش‌نمایش تصویر دوره" />
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="intro_video">ویدیوی معرفی دوره:</label>
          <input
            type="file"
            id="intro_video"
            name="intro_video"
            accept="video/*"
            onChange={handleChange}
          />
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_free"
              checked={formData.is_free}
              onChange={handleChange}
            />
            دوره رایگان است
          </label>
        </div>

        {!formData.is_free && (
          <>
            <div className="form-group">
              <label htmlFor="price">قیمت دوره (تومان):</label>
              <input
                type="number"
                id="price"
                name="price"
                value={formData.price}
                onChange={handleChange}
                min="0"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="discount">تخفیف (درصد):</label>
              <input
                type="number"
                id="discount"
                name="discount"
                value={formData.discount}
                onChange={handleChange}
                min="0"
                max="100"
                step="0.01"
                placeholder="0 تا 100"
              />
              {parseFloat(formData.discount) > 0 && (
                <div className="discount-info">
                  <p>قیمت اصلی: {parseFloat(formData.price).toLocaleString()} تومان</p>
                  <p>تخفیف: {formData.discount}%</p>
                  <p className="final-price">
                    قیمت نهایی: {calculateFinalPrice().toLocaleString()} تومان
                  </p>
                </div>
              )}
            </div>
          </>
        )}

        <div className="form-group">
          <label htmlFor="prerequisites">پیش‌نیازها:</label>
          <textarea
            id="prerequisites"
            name="prerequisites"
            value={formData.prerequisites}
            onChange={handleChange}
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="duration">مدت زمان دوره:</label>
          <input
            type="text"
            id="duration"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            placeholder="مثال: 20 ساعت"
          />
        </div>

        <div className="form-group">
          <label htmlFor="level">سطح دوره:</label>
          <select
            id="level"
            name="level"
            value={formData.level}
            onChange={handleChange}
          >
            <option value="beginner">مقدماتی</option>
            <option value="intermediate">متوسط</option>
            <option value="advanced">پیشرفته</option>
          </select>
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_available"
              checked={formData.is_available}
              onChange={handleChange}
            />
            دوره در دسترس است
          </label>
        </div>

        {message && (
          <div
            className={
              message.includes("موفقیت") ? "success-message" : "error-message"
            }
          >
            {message}
          </div>
        )}

        <div className="form-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? "در حال ایجاد دوره..." : "ایجاد دوره"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/admin/courses/list")}
            className="cancel-button"
          >
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCourse;
